import { Box, Stack } from '@packages/shared';
import { ActionsBar } from '../ActionsBar/ActionsBar';

export type SampleOrderContentProps = {
  pageContent: React.ReactNode;
  actionBarContent: React.ReactNode;
};

export const SampleOrderContent = ({ pageContent, actionBarContent }: SampleOrderContentProps) => (
  <Stack
    direction="column"
    justifyContent="flex-end"
    sx={{
      height: '100%',
      maxHeight: '100vh',
      minHeight: '50vh',
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        flex: '1 1 90%',
        overflowX: 'hidden',
        overflowY: 'auto',
        scrollBehavior: 'smooth',
        backgroundColor: 'grey.light',
        p: [2, 2, 3],
      }}
    >
      {pageContent}
    </Box>
    <ActionsBar>{actionBarContent}</ActionsBar>
  </Stack>
);
